// Central defaults for all CMS-editable content on the site.
// Public pages fetch from /api/site-content/<key> and merge over these.

export const DEFAULTS = {
  home_hero: {
    label_tag: "80:20 Training × Voodoo Boyz Athletics",
    line1: "Train Like",
    line2: "The Top 20%",
    line3: "Play Like It.",
    subtitle: "Elite football performance training, position-specific coaching, 7v7 competition, and NCAA recruiting support built for athletes who refuse average.",
    cta_primary_text: "Join As Athlete",
    cta_primary_link: "/register",
    cta_secondary_text: "College Coaches",
    cta_secondary_link: "/coaches-portal",
    cta_tertiary_text: "View Programs",
    cta_tertiary_link: "/programs",
    hero_image: "https://images.unsplash.com/photo-1488474739786-757973c2dff6?auto=format&fit=crop&w=2400&q=80",
  },
  home_mission: {
    label_tag: "Our Mission",
    title: "Built for the athletes who show up when no one is watching.",
    paragraph_1: "80:20 Training exists because most athletes settle for 80% and wonder why they get passed over. We coach the other 20% — the details, the reps, the film, the recruiting work — that separates a starter from a signee.",
    paragraph_2: "From the trenches to the perimeter, our programming is engineered for football. Our coaches have D1 relationships, NFL experience, and a track record of turning overlooked kids into recruited ones.",
    cta1_text: "Meet the Coaches",
    cta1_link: "/coaches",
    cta2_text: "How Recruiting Works",
    cta2_link: "/recruiting",
  },
  home_stats: {
    items: [
      { number: "500+", label: "Athletes Trained" },
      { number: "60+", label: "College Signees" },
      { number: "12", label: "Years Experience" },
    ],
  },
  home_features: {
    label_tag: "Why Athletes Choose Us",
    title: "More than a gym. A pipeline.",
    items: [
      { title: "Elite Programming", text: "Football-specific strength, speed, and skill work. No generic gym stuff.", icon: "Flame" },
      { title: "Proven Results", text: "60+ college signees, hundreds of college-bound athletes in every division.", icon: "Trophy" },
      { title: "Recruiting Machine", text: "Direct relationships with 300+ college programs actively recruiting our athletes.", icon: "Target" },
      { title: "Real Community", text: "Train with athletes who push each other. Coached by ones who've done it.", icon: "Users" },
    ],
  },
  home_cta: {
    label_tag: "Ready?",
    title: "Your recruiting timeline starts today.",
    subtitle: "Book your first session, get evaluated, and start your recruiting profile.",
    cta_primary_text: "Get Started",
    cta_primary_link: "/register",
    cta_secondary_text: "See Pricing",
    cta_secondary_link: "/pricing",
    newsletter_label: "Newsletter",
    newsletter_title: "Get weekly drills, film breakdowns, and recruiting tips.",
  },
  page_hero_programs: {
    label_tag: "Programs",
    line1: "Every Rep.",
    line2: "Every Position.",
    line3: "Every Level.",
    subtitle: "From strength and speed to film study and recruiting — pick the path that fits your goals.",
  },
  page_hero_coaches: {
    label_tag: "Know the Coaches",
    line1: "The",
    line2: "Architects",
    line3: "of your development.",
    subtitle: "Every coach on staff has played, coached, or scouted at the highest levels. Real experience. Real relationships.",
  },
  page_hero_recruiting: {
    label_tag: "NCAA Recruiting",
    line1: "Get",
    line2: "Recruited.",
    line3: "Get Signed.",
    subtitle: "Talent is table stakes. We handle the exposure, evaluation, and outreach that turns talent into offers.",
    cta_primary_text: "Start My Profile",
    cta_primary_link: "/register",
    cta_secondary_text: "Recruiting Package",
    cta_secondary_link: "/pricing",
    hero_image: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&w=1600&q=80",
  },
  page_hero_pricing: {
    label_tag: "Membership & Pricing",
    line1: "Pick your",
    line2: "weight class.",
    line3: "",
    subtitle: "Flexible packages built for individual athletes, teams, and serious recruits. Cancel monthly plans anytime.",
  },
  page_hero_events: {
    label_tag: "Events",
    line1: "Camps.",
    line2: "Combines.",
    line3: "Competition.",
    subtitle: "Register for our upcoming camps, combines, tournaments, and training sessions. All payments secured through Stripe.",
  },
  page_hero_contact: {
    label_tag: "Contact",
    line1: "Let's",
    line2: "Talk Ball.",
    line3: "",
    subtitle: "",
  },
  recruiting_pillars: {
    section_title: "Six pillars. One outcome.",
    section_label: "The Process",
    items: [
      { title: "Profile Building", text: "We craft a college-ready profile — measurables, transcript, film, highlight reel — that gets you on coaches' radars." },
      { title: "Highlight Support", text: "Editing, curating, and pushing your film to the coaches who need to see it." },
      { title: "Player Evaluation", text: "Honest, expert evaluation. We tell you where you are and what levels are realistic — then we build the plan." },
      { title: "Exposure", text: "Combines, showcases, 7v7 tournaments, and social media — we get your name and film in front of decision-makers." },
      { title: "College Coach Connection", text: "Direct relationships with 300+ programs. We don't just email — we pick up the phone." },
      { title: "NCAA Guidance", text: "Eligibility Center, official/unofficial visits, offer navigation, and commitment planning." },
    ],
  },
  contact_info: {
    email: "8020sporttraining@gmail.com",
    phone_1: "303.506.7541",
    phone_2: "720.648.9934",
    address: "",
    social_x: "https://x.com/8020VoodooBoyz",
    social_x_handle: "@8020VoodooBoyz",
    social_instagram: "",
    social_instagram_handle: "",
    social_facebook: "",
    social_youtube: "",
    social_tiktok: "",
    social_hudl: "",
  },
  brand: {
    site_name: "80:20 Training",
    site_subname: "Voodoo Boyz Athletics",
    monogram: "80",
    tagline: "Built for athletes who refuse average.",
    logo_url: "",
    footer_about: "Elite football training and NCAA recruiting for athletes ready to reach the next level.",
  },
};
